export const messagingMutationKeys = {
  createMessage: ['createMessage'],
};
